import emptyImage from '@fukuri-admins/assets/images/circle-company.svg';
import {
  ButtonLink,
  ChevronDownIcon,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  PlusIcon,
  Stack,
} from '@fukuri-admins/ui/common';
import { buttonVariants } from '@fukuri-admins/ui/shared/buttonVariants';
import styles from './emptyStyles.module.scss';

type Props = {
  /**
   * アクティベーションコードによる追加メニューを表示するか
   *
   * true のとき「新規追加」ボタンがドロップダウンになり、
   * メールアドレス追加・アクティベーションコード追加の 2 メニューを表示する
   */
  isActivationCodeEnabled: boolean;
  /** 「メールアドレスで追加」メニュー選択時のコールバック */
  onClickAddUserByEmail: () => void;
  /** 「アクティベーションコードで追加」メニュー選択時のコールバック */
  onClickAddUserByActivationCode: () => void;
};

/**
 * 利用者一覧 Empty 状態 Presentation
 *
 * 利用者が 0 件のときに表示する
 */
export const UserListEmptyPresentation: React.FC<Props> = ({
  isActivationCodeEnabled,
  onClickAddUserByEmail,
  onClickAddUserByActivationCode,
}) => (
  <Stack
    gap={24}
    alignItems='center'
    justifyContent='center'
    height='100%'
    className={styles.container}
  >
    <img src={emptyImage} alt='empty list image' />
    <p className={styles.message}>利用者が登録されていません</p>
    {isActivationCodeEnabled ? (
      <DropdownMenu>
        <DropdownMenuTrigger>
          <button type='button' className={buttonVariants({ variant: 'primary' })}>
            新規追加
            <ChevronDownIcon size='xs' />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='end'>
          <DropdownMenuItem onSelect={onClickAddUserByEmail}>メールアドレスで追加</DropdownMenuItem>
          <DropdownMenuItem onSelect={onClickAddUserByActivationCode}>
            アクティベーションコードで追加
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    ) : (
      <ButtonLink
        variant='primary'
        size='md'
        icon={<PlusIcon size='xs' />}
        iconPosition='left'
        to='/users/new'
      >
        新規追加
      </ButtonLink>
    )}
  </Stack>
);
